<template>
	<div class="school-invoices">
		<ViewInvoice />
		<PaymentBreakdown />
		<PayInvoice />
		<RequestInvoiceFinance />

		<div class="row">
			<div class="col-12 col-lg-6" v-if="school_invoices.length > 0">
				<div class="title-content clearfix">
					<div class="title f-l">My Schools Invoices</div>
				</div>
				<div class="scroll-content">
					<scrollbar>
						<div class="row">
							<div
								class="col-md-6 col-lg-12"
								v-for="(invoice, i) in school_invoices"
								:key="i"
								@click="viewSchoolInvoice(invoice)"
							>
								<div class="invoice-box">
									<div class="date-box clearfix">
										<div class="txt f-l">Created At:</div>
										<div class="date f-l">
											{{
												moment(
													invoice.created_date,
												).format('Do MMM YYYY')
											}}
										</div>
										<div class="status f-r">
											{{ invoice.invoice_status }}
										</div>
									</div>
									<div class="clearfix">
										<div class="name-box f-l">
											<div class="insurance">
												{{
													invoice.student_details
														? invoice
																.student_details
																.student_name
														: '-'
												}}
											</div>
											<div class="ref">
												{{
													invoice.school_details
														? invoice.school_details
																.school_name
														: '-'
												}}
											</div>
											<div class="txt tx-uppercase">
												ID:
												{{
													invoice.parent_fee_invoice_system_ref
												}}
											</div>
										</div>
										<div class="price-box f-r">
											<div class="price tx-blue">
												{{ invoice.invoice_currency }}
												{{
													utils.numberWithCommas(
														invoice.total_amount
															.toString()
															.split('.')[0],
													)
												}}
												<span
													class="point"
													v-if="
														invoice.total_amount
															.toString()
															.includes('.')
													"
													>.{{
														invoice.total_amount
															.toString()
															.split('.')[1]
															.slice(0, 2)
													}}</span
												>
											</div>
											<div class="txt">Total</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</scrollbar>
				</div>
			</div>
			<div
				class="col-12 col-lg-6"
				v-if="!school_invoices || school_invoices.length === 0"
			>
				<div class="white-content">
					<div class="title">No Schools Invoices Found.</div>
				</div>
			</div>
			<div class="col-12 col-lg-5">
				<Advert />
			</div>
		</div>
	</div>
</template>

<script>
import school_invoice from '../rsc/stores/fee-invoice.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	async beforeCreate() {
		Event.$emit('loader:show', true);
		let token = await $session.get('token');

		if (!token) {
			Event.$emit('token:not-found', true);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule('school_invoice');
	},
	created() {
		utils.registerModule('school_invoice', school_invoice, this.$store);
	},
	components: {
		Advert: () => import('../templates/ads/advert.vue'),
		ViewInvoice: () => import('./view-invoice.vue'),
		PaymentBreakdown: () => import('./payment-breakdown.vue'),
		PayInvoice: () => import('./pay-invoice.vue'),
		RequestInvoiceFinance: () => import('./request-invoice-finance.vue'),
		scrollbar: VueScrollbar,
	},
	data() {
		return {
			moment,
			utils,
		};
	},
	computed: {
		...mapGetters(['loading', 'school_invoices']),
	},
	methods: {
		...mapActions(['viewSchoolInvoice', 'fetchData']),
		async openInvoice() {
			let parent_fee_invoice_system_ref = await $session.get(
				'selected_invoice_page',
			);

			if (parent_fee_invoice_system_ref) {
				console.log(parent_fee_invoice_system_ref);
				await this.viewSchoolInvoice({
					parent_fee_invoice_system_ref,
				});
				await $session.remove('selected_invoice_page');
			}
		},
	},
	async mounted() {
		utils.registerModule('school_invoice', school_invoice, this.$store);
		await this.openInvoice();
		await this.$store.dispatch('fetchData', this.$router);
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.school-invoices {
	.scroll-content {
		height: calc(100vh - 230px);
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}

	.invoice-box {
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}

		.date-box {
			margin: -1px 15px 0 0;
			width: 100%;

			.status {
				font-size: 11px;
				text-align: right;
			}
			.txt {
				font-size: 13px;
				margin: 4px 5px 15px 0;
			}

			.month,
			.year {
				color: @grey;
				font-size: 14px;
				font-weight: 600;
				line-height: 12px;
				margin: 8px 5px;
			}

			.date {
				font-size: 14px;
				font-family: var(--font-bold);
				color: var(--text-color);
				margin: 4px 0 2px 5px;
			}
		}

		.name-box {
			.insurance {
				font-size: 17px;
				color: var(--text-color);
				font-family: var(--font-bold);
				line-height: 15px;
			}

			.txt {
				font-weight: 600;
				color: @grey;
				font-size: 14px;
			}
		}

		.categories {
			margin: 10px 0 0 0;

			.category:last-child {
				.circle {
					display: none;
				}
			}

			.name {
				font-weight: 600;
				color: #9c7bfc;
				font-size: 13px;
			}

			.circle {
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background: #9c7bfc;
				margin: 11px 10px 0 10px;
			}
		}

		.price-box {
			.price {
				font-size: 20px;
				line-height: 15px;
				font-family: var(--font-bold);
				margin: 5px 0 0 0;

				.point {
					font-size: 11px;
				}
			}

			.txt {
				font-weight: 600;
				color: @grey;
			}
		}
	}

	.payment-card {
		.txt-main {
			font-size: 14px;
			font-weight: 600;
		}
		.amount {
			color: var(--ne-blue);
			font-size: 16px;
		}

		.balance {
			font-size: 15px;
			font-weight: 600;
			margin: 30px 0;

			.amount {
				color: var(--ne-green);
			}
		}
		.button-box {
			margin: 30px 0 0 0;

			.btn {
				margin: 5px 0;
			}
		}
	}

	.fee-card {
		.sum-total {
			.total {
				text-align: right;
				color: var(--ne-blue);
				font-size: 18px;
				font-weight: 600;
				padding: 10px 0 10px 30px;
				border-bottom: solid var(--text-color) 3px;
				border-top: solid var(--text-color) 3px;
			}
		}
		.term {
			margin: 0 0 40px 0;

			&.title {
				font-size: 14px;
				font-weight: 600;
			}
			.item-desc {
				font-size: 13px;
			}
			.name {
				font-size: 13px;
				font-weight: 600;
			}

			.small-title {
				font-size: 11px;
				font-weight: 600;
				margin: 10px 0 3px 5px;
			}
		}

		.price-item {
			font-size: 14px;

			.item-title {
			}
			.amount {
				text-align: right;
				font-weight: 600;
			}
		}
		.total-box {
			border-top: solid 1px var(--border-grey);
			border-bottom: solid 1px var(--border-grey);
			padding: 7px 0;
			margin: 10px 0 0 0;
			font-weight: 600;

			.amount {
				color: var(--ne-blue);
				text-align: right;
			}
		}

		.status {
			font-size: 12px;
			text-transform: uppercase;
			font-weight: 600;

			&.tx-yellow {
				color: var(--ne-yellow);
			}
		}
		.ref {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.class {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.time {
			font-size: 13px;
			color: var(--ne-green);
		}

		.s-class {
			color: #9c7bfc;
			font-size: 13px;
		}
		.total {
			color: var(--ne-blue);
			font-size: 15px;
			font-weight: 600;
			padding: 0 0 10px 0;
			margin: 0 0 20px 0;
			border-bottom: solid 1px var(--border-grey);
		}
	}
}
</style>
